import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import { useLang } from "@/context/LanguageContext";
import { applySeo } from "@/lib/utils";
import Cursor from "@/components/site/Cursor";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";

const PAGE_BY_PATH = {
  "/": "home",
  "/about": "about",
  "/services": "services",
  "/journal": "journal",
  "/portfolio": "portfolio",
  "/library": "library",
};

export default function SiteLayout({ children }) {
  useSmoothScroll();
  const { lang, t } = useLang();
  const { pathname } = useLocation();

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  // Page-level SEO (detail routes manage their own SEO from the loaded item).
  useEffect(() => {
    if (/^\/(journal|portfolio|library)\/[^/]+/.test(pathname)) return;
    const page = PAGE_BY_PATH[pathname];
    const s = (t.seo && t.seo[page]) || {};
    applySeo({ title: s.title, description: s.description, path: pathname, enPath: pathname, roPath: pathname });
  }, [pathname, lang, t]);

  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="om-site relative bg-paper text-ink min-h-screen">
      <Cursor />
      <Nav />
      <main>
        {children ?? <Outlet />}
      </main>
      <Footer />
    </div>
  );
}
